import React from 'react'

const IconReportingNew = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M34 38H6V2H24L34 12V38Z" stroke="currentcolor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M19.9995 7.99951V15.9995H27.9995" stroke="currentcolor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  )
}

export default IconReportingNew